function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cc7b4e;}.cls-2,.cls-3{fill:#fff;}.cls-3{font-size:40px;font-family:GenJyuuGothic-Monospace-Bold, Gen Jyuu Gothic Monospace;font-weight:700;letter-spacing:0.5em;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 273.53,
  cy: 273.53,
  r: 273.53
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M424.76,142.87h0c-7.1-3.31-9.85-2.68-13.16,4.43l-19.17,39.84c-1,1.79-5.12,5.69-6.88,4.67l-3.44-2c-1.39-.8-1.73-5.36-1-6.78l29-57.57c3.92-6.79,1.87-11-4.93-15h0c-6.79-3.92-11.49-3.58-15.41,3.21l-35,53.39c-1,1.64-5.52,3.73-7.2,2.76l-3.74-2.16c-1.32-.76.14-5.73.93-7l25.41-37.32c4.5-6.43,3.67-9.12-2.75-13.62h0c-3.69-2.58-11.92-1.27-16.59,5.39l-20.11,27.58-.72,1c-.22.39.21-.31,0,.07a12.24,12.24,0,0,0-.67,1.23c-16.17,29.77-25.47,65.66-9.32,84.54l-25.08,43.45-7.82-13.54-33.52-58.06-43.72-75.72A14.26,14.26,0,1,0,185.16,140l49.28,147.43a5.5,5.5,0,0,0,3.8,3.53c7.09,1.81,20.3-2.08,30.57-6.07l9.63,16.68-43.77,75.83a14.3,14.3,0,0,0,5.21,19.48h0a14.31,14.31,0,0,0,19.48-5.22l35.55-61.57,35.65,61.75A14.3,14.3,0,0,0,350,397.05h0a14.29,14.29,0,0,0,5.22-19.47l-43.89-76,33.31-57.7c24.43,4.55,51.95-20.83,69.66-49.71q.38-.57.72-1.2c.22-.38-.17.34.05,0l.54-1.14,12.74-31.84C431.7,152.83,431.87,146.19,424.76,142.87Z",
  transform: "translate(-27.4 -24.11)"
});

var _ref5 = /*#__PURE__*/React.createElement("text", {
  className: "cls-3",
  transform: "translate(112.86 443.22)"
}, "\u4ECA\u5929\u5403\u4EC0\u9EBC\uFF1F");

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 547.06 547.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LOGO_v2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c4785b22.svg";
export { ForwardRef as ReactComponent };